"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parent_1 = require("./parent");
exports.remove = function (element) {
    var p = parent_1.parent(element);
    if (p !== undefined) {
        p.removeChild(element);
    }
};
